import { customAlphabet } from "nanoid/non-secure";

export const nanoid = customAlphabet("1234567890abcdef", 10);

export function new_nanoid(size = 10, alphabet = "1234567890abcdef") {
	const fn = customAlphabet(alphabet, size);
	return fn();
}
